import { z } from "zod";

/**
 * Delivery platforms (`STORE_SETTINGS_DELIVERY_PROVIDER`).
 *
 * A store picks from the platforms its market offers and says what each costs
 * it. The commission is what makes `09-reports.md` § 1's before-and-after
 * distinction reportable — "the one restaurants care most about and the one
 * most POS systems get wrong".
 */

export const DeliveryProviderSchema = z.object({
  id: z.uuid(),
  providerCode: z.string(),
  name: z.string(),
  isEnabled: z.boolean(),
  /** Basis points, never a float: 1500 is 15.00%. */
  commissionBp: z.number().int(),
  sort: z.number().int(),
});
export type DeliveryProvider = z.infer<typeof DeliveryProviderSchema>;

export const SaveDeliveryProvidersSchema = z.object({
  providers: z
    .array(
      z.object({
        providerCode: z.string().min(1).max(60),
        name: z.string().min(1).max(120),
        isEnabled: z.boolean().default(true),
        commissionBp: z.number().int().min(0).max(10_000).default(0),
      }),
    )
    .max(20),
});

/** What this store's market allows, so a form need not hard-code a country's platforms. */
export const DeliveryProviderOptionsSchema = z.object({
  available: z.array(z.string()),
});
